import React, { useContext, useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import "./History_Inner_Page.css";
import History_Vendor from "../history-vendor/History_Vendor";
import History_Expert from "../history-expert/History_Expert";
import Expert_Tab_History from "../Expert-Tab_History/Expert_Tab_History";
import Vendor_Tab_History from "../Vendor-Tab-History/Vendor_Tab_History";
import { getVendorExpertList } from "../../../../features/admin/vendor_expert/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../../utils/context";

function History_Inner_Page() {
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);
  const [activeTab, setActiveTab] = useState("vendor");
  console.log(userdata, "userdatauserdatauserdatauserdata");

  const vendorexpertlist = useSelector(
    (state) => state?.vendor_expert?.vendorexperts?.history,
  );

  useEffect(() => {
    // if (!userdata?.token) return;

    dispatch(
      getVendorExpertList({
        type: activeTab,
      }),
    );
  }, [activeTab, dispatch]);

  return (
    <section className="vendor-expert-section">
      <div className="container">
        {userdata?.type === "customer" && (
          <Tab.Container
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <div className="vendor-expert-header">
              <Nav variant="pills" className="vendor-expert-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="vendor">Vendors</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="expert">Experts</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <Tab.Content className="mt-4">
              <Tab.Pane eventKey="vendor">
                <History_Vendor vendorexpertlist={vendorexpertlist} />
              </Tab.Pane>
              <Tab.Pane eventKey="expert">
                <History_Expert vendorexpertlist={vendorexpertlist} />
                <div className="text-center"></div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        )}
      </div>

      {userdata?.type === "expert" && <Expert_Tab_History />}

      {userdata?.type === "vendor" && <Vendor_Tab_History />}
    </section>
  );
}
export default History_Inner_Page;
